import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import ArrowIcon from '../../../img/sprite/arrow-right.svg';

const Wrapper = styled.div`
  ${props => !props.referredBy ? 'display: none;' : ''}
`;

const LinkBack = styled.a`
  ${props => props.a}
  display: inline-block;
  padding: 15px 30px;
  background-color: #ccc;
  width: 100%;
  text-decoration: none;
  color: #444;
  text-overflow: ellipse;
`;

const Svg = styled.svg`
  ${props => props.svg}
  transform: rotate(180deg);
  font-size: 13px;
  margin-top: -2px;
`;

const Referrer = ({ referredBy }) => {
  const backMessage = () => {
    if (referredBy.includes('//purchase.lifeway') || referredBy.includes('//www.lifeway') || referredBy.includes('//lifeway')) {
      return 'Continue Shopping';
    }

    const matchedDomainName = referredBy.match(/:\/\/(.[^/]+)/);

    return (matchedDomainName?.length > 1) ? `back to ${matchedDomainName[1]}` : 'back';
  };

  return (
    <Wrapper referredBy={referredBy}>
      {referredBy &&
        <LinkBack href={referredBy}>
          <Svg><use xlinkHref={`#${ArrowIcon.id}`} /></Svg>{backMessage()}
        </LinkBack>
      }
    </Wrapper>
  );
};

const { string } = PropTypes;

Referrer.propTypes = {
  referredBy: string
};

export default Referrer;
